import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface ConversationSkeletonProps {
  count?: number;
  className?: string;
}

const ConversationSkeleton: React.FC<ConversationSkeletonProps> = ({
  count = 5,
  className
}) => {
  const { isDarkMode } = useTheme();
  
  return (
    <div className={cn("space-y-1", className)}>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          className={cn(
            "px-4 py-3.5 animate-pulse",
            isDarkMode ? "hover:bg-dark-300/30" : "hover:bg-gray-100"
          )}
        >
          <div className="flex items-center space-x-4">
            {/* Avatar */}
            <div className={cn(
              "w-16 h-16 rounded-full",
              isDarkMode ? "bg-dark-300" : "bg-gray-200"
            )} />
            
            {/* Content */}
            <div className="flex-1 space-y-2">
              {/* Name */}
              <div className={cn(
                "h-5 rounded w-1/3",
                isDarkMode ? "bg-dark-300" : "bg-gray-200"
              )} />
              
              {/* Location */}
              <div className={cn(
                "h-4 rounded w-1/2",
                isDarkMode ? "bg-dark-300" : "bg-gray-200"
              )} />
              
              {/* Message */}
              <div className={cn(
                "h-4 rounded w-3/4",
                isDarkMode ? "bg-dark-300" : "bg-gray-200"
              )} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationSkeleton;